// extracted by mini-css-extract-plugin
module.exports = {"sectionName":"section-name_sectionName__Oqqpo"};